import React, { useState, useEffect, lazy, Suspense } from 'react'
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import ProtectedRoute from '../../components/protectedRoute/ProtectedRoute';
import ProtectedRouteFrontend from '../../components/protectedRouteFrontend/ProtectedRouteFrontend';
import LoadingIndicator from "../../components/general/loadingIndicator/LoadingIndicator";
import serviceRest from '../../services/serviceRest'
// backend
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import MediaServerForm from '../mediaserver/MediaServerForm';
import MediaServerDenied from '../mediaserver/MediaServerDenied';

//FRONTEND SPECIAL (lazy)
const AdminResponse = lazy(() => import("../frontend/adminResponse/AdminResponse"))
//404
// import NotFound from '../notFound/NotFound';
const NotFound = lazy(() => import("../notFound/NotFound"))
// frontend (lazy)
const Home = lazy(() => import("../frontend/home/Home"))
const About = lazy(() => import("../frontend/about/About"))
const Cart = lazy(() => import("../frontend/cart/Cart"))
const Contact = lazy(() => import("../frontend/contact/Contact"))
const FAQ = lazy(() => import("../frontend/faq/Faq"))
const Messages = lazy(() => import("../frontend/messages/Messages"))
const Orders = lazy(() => import("../frontend/orders/Orders"))
const Profil = lazy(() => import("../frontend/profil/Profil"))
const ReservationsFront = lazy(() => import("../frontend/reservations/Reservations"))
const ConnexionInscription = lazy(() => import("../frontend/connexionInscription/ConnexionInscription"))
const AccountActivation = lazy(() => import("../frontend/accountActivation/AccountActivation"))
const PswLost = lazy(() => import("../frontend/pswLost/PswLost"))
const PswLostReset = lazy(() => import("../frontend/pswLost/PswLostReset"))
const Planning = lazy(() => import("../frontend/planning/Planning"))
const PlanningAlone = lazy(() => import("../frontend/planning/PlanningAlone"))
const PlanningGroup = lazy(() => import("../frontend/planning/PlanningGroup"))
const DispoUNIGE = lazy(() => import("../frontend/dispo/DispoUNIGE"))
const MediaServerList = lazy(() => import("../mediaserver/MediaServerList"))

// backend (lazy)
const Login = lazy(() => import("../backend/login/Login"))
const Reservations = lazy(() => import("../backend/reservations/Reservations"))
const Activity = lazy(() => import("../backend/activity/Activity"))
const Calendar = lazy(() => import("../backend/calendar/Calendar"))
const Customer = lazy(() => import("../backend/customer/Customer"))
const Emoluments = lazy(() => import("../backend/emoluments/Emoluments"))
const ExportGS = lazy(() => import("../backend/exportGS/ExportGS"))


const Container = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [institution, setInstitution] = useState("");
  const [frontendColor, setFrontendColor] = useState("");
  const [ssoActive, setSsoActive] = useState(false);
  const [releaseNum, setReleaseNum] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [language, setLanguage] = useState("FR");

  useEffect(() => {
    let pathSplit = window.location.pathname.split("/")

    if (pathSplit.length >= 4) {
      if (pathSplit[3]==="planning") {
        pathSplit[3] = pathSplit[4]
      }
      let param = { "institution": pathSplit[3]};
      serviceRest.post('/react/frontendController/getConfig', param).then((response) => {
        // console.log(response.data)
        setFrontendColor(response.data.frontendColor)
        setSsoActive(response.data.sso)
        setInstitution(pathSplit[3])
        setReleaseNum(response.data.releaseNum)
      }, (error) => {
        console.log(error);
      });
      
    }
    setIsLoaded(true)
  }, []);

  return (
    isLoaded ?
      <Suspense fallback={<LoadingIndicator open={true} />}>
        <Router>
          <div>
            <Header institution={institution} frontendColor={frontendColor} refresh={refresh} language={language} setLanguage={setLanguage} />
            <Switch>
              <Route exact path="/">
                <Redirect to="/backend/connexion" />
              </Route>
              {/* backend */}
              <Route exact path="/backend/connexion" component={Login} />
              <ProtectedRoute exact path="/backend/meetings/:resID?" component={Reservations} />
              <ProtectedRoute exact path="/backend/meetings/:action/:resID?" component={Reservations} />
              <ProtectedRoute exact path="/backend/activites" component={Activity} module="activites" />
              <ProtectedRoute exact path="/backend/calendriers" component={Calendar} module="calendriers" />
              <ProtectedRoute exact path="/backend/clients" component={Customer} />
              <ProtectedRoute exact path="/backend/emoluments" component={Emoluments} module="emoluments" />
              <ProtectedRoute exact path="/backend/exportGS" component={ExportGS} />
              {/* fin backend */}
              {/* frontend */}
              <Route exact path='/frontend/home/:institution?' render={(props) => <Home {...props} language={language} />} />
              <Route exact path="/frontend/about/:institution?" component={About} />
              <ProtectedRouteFrontend setRefresh={setRefresh} institution={institution} exact path="/frontend/cart/:institution?" component={Cart} />
              <Route exact path="/frontend/contact/:institution?" component={Contact} />
              <Route exact path="/frontend/faq/:institution?" render={(props) => <FAQ {...props} language={language} />} />
              <ProtectedRouteFrontend setRefresh={setRefresh} refresh={refresh} institution={institution} exact path="/frontend/messages/:institution?" component={Messages} />
              <ProtectedRouteFrontend institution={institution} frontendColor={frontendColor} exact path="/frontend/orders/:institution?/:orderID?/:msg?" component={Orders} />
              <ProtectedRouteFrontend institution={institution} exact path="/frontend/profil/:institution?" component={Profil} />
              <Route exact path="/frontend/reservations/:institution?" component={ReservationsFront} />
              <Route exact path="/frontend/connexion/:institution?" component={ConnexionInscription} />
              <Route exact path="/frontend/pswLost/:institution?" component={PswLost} />
              <Route exact path='/frontend/activateAccount/:key?' component={AccountActivation} />
              <Route exact path='/frontend/accountpasswordReset/:key?' component={PswLostReset} />
              <Route exact path="/frontend/planning/:institution?/:lieuID?" component={Planning} />
              <Route exact path="/frontend/light/planning/:institution?/:lieuID?" component={Planning} />
              <Route exact path="/frontend/planningAlone/:institution?/:lieuID?" component={PlanningAlone} />
              <Route exact path="/frontend/planningGroup/:institution?/:lieuID?" component={PlanningGroup} />
              <ProtectedRoute exact path="/frontend/adminResponse/:institution?/:orderID?" component={AdminResponse} />
              {/* Spécial UNIGE (protégé par shib) */}
              <Route exact path="/protected/dispo/:institution?" component={DispoUNIGE} />
              {/* fin frontend */}
              {/* Spécial 2 UNIGE (protégé par shib => média server) */}
              <Route exact path="/mediaserver/list" component={MediaServerList} />
              <Route exact path="/mediaserver/form/:mediaserverId?" component={MediaServerForm} />
              <Route exact path="/mediaserver/accessDenied" component={MediaServerDenied} />
              
              {/* other path => 404 */}
              <Route exact path="*" component={NotFound} />
            </Switch>
            <Footer frontendColor={frontendColor} ssoActive={ssoActive} releaseNum={releaseNum} />
          </div>
        </Router>
      </Suspense>

      :
      <LoadingIndicator open={true} />
  )
}


export default Container;



